import React from 'react';

import Icon from './Icon';


const Gender = (props) => {
    return (
        <div className="symbols">
            <div className="gender">
                {props.gender && props.gender === 2 ?
                    <Icon type="venus"/>
                    :
                    <div></div>
                }
                {props.gender && props.gender === 1 ?
                    <Icon type="mars"/>
                    :
                    <div></div>
                }
                {props.gender && props.gender === 3 ?
                    <div className="group-icon">
                        <Icon type="venus-mars"/>
                    </div>
                    :
                    <div></div>
                }
                {props.gender && props.gender === 4 ?
                    <div className="group-icon">
                        <Icon type="venus-double"/>
                    </div>
                    :
                    <div></div>
                }
                {props.gender && props.gender === 5 ?
                    <div className="group-icon">
                        <Icon type="mars-double"/>
                    </div>
                    :
                    <div></div>
                }
                {props.gender && props.gender === 6 ?
                    <div className="group-icon-trav">
                        <Icon type="transgender"/>
                    </div>
                    :
                    <div></div>
                }
            </div>
        </div>

    )
};

export default Gender;
